import { render, staticRenderFns } from "./preferenceAnalysis.vue?vue&type=template&id=4f357e44&scoped=true&"
import script from "./preferenceAnalysis.vue?vue&type=script&lang=js&"
export * from "./preferenceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./preferenceAnalysis.vue?vue&type=style&index=0&id=4f357e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f357e44",
  null
  
)

export default component.exports